import { HashRouter as Router, Routes, Route } from 'react-router-dom';
import { ROUTE_PATHS } from '@/lib/index';
import Home from '@/pages/Home';
import Contractors from '@/pages/Contractors';
import Careers from '@/pages/Careers';
import Investment from '@/pages/Investment';

function App() {
  return (
    <Router>
      <Routes>
        <Route path={ROUTE_PATHS.HOME} element={<Home />} />
        <Route path={ROUTE_PATHS.CONTRACTORS} element={<Contractors />} />
        <Route path={ROUTE_PATHS.CAREERS} element={<Careers />} />
        <Route path={ROUTE_PATHS.INVESTMENT} element={<Investment />} />
      </Routes>
    </Router>
  );
}

export default App;
